import { SelectionModel } from '@angular/cdk/collections';
import { Injectable } from '@angular/core';
import { FetchElementAllCategoriesResult } from '../../services/eleview/eleview-backface';
import { Label } from '../../services/eleview/types/label';
// recviewçæ»ç¶ææ°æ®ç»æ
import { ElementViewDigest } from '../model/element-columns-digest';
import { IFetchDataParam, IFetchDataResult, IRecordViewProcess, ConditionalValue } from '../model/model';
import { Operate } from '../model/operate';
import { ownerElement, OwnerByEnum, IColumnType, ColumnsWithLetter } from '../../services/eleview/types/model';
import { ConditionalTemplate, CTType } from '../../element/service/recordview-param';

export const defaultColumnsItem = ElementViewDigest.fromInterface({
	Name: '(ç¼ºçæ¾ç¤ºå)',
	Owner: ownerElement,
	OwnerBy: OwnerByEnum.ownerByEle
});
export const combLabelColumnsItem = ElementViewDigest.fromInterface({
	Name: '(æææ ç­¾å¹¶é)',
	Owner: '',
	OwnerBy: OwnerByEnum.unknow
});
export class ConditionalTemplateRunner implements ConditionalTemplate {
	Type: CTType;
	Field: string;
	Setting: any;
	Data: ConditionalValue;
	enable: boolean;
	public static fromInterface(data: ConditionalTemplate) {
		const rev = new ConditionalTemplateRunner();
		Object.assign(rev, data);
		rev.Data = {
			Field: data.Field,
			Type: data.Type,
			Value: null
		};
		return rev;
	}
}
@Injectable()
export class ServiceData {
	// æ¡ä»¶æ¨¡æ¿çåæ°æ°æ®
	conditionalTemplates: ConditionalTemplateRunner[];
	// æ¡ä»¶æ¨¡æ¿çç¨æ·æ°æ®
	rowProcesses: IRecordViewProcess[] = [];
	// ä¸è·éæ°æ®è¡ï¼ä¸æ¹å·¥å·æ çå¤çåè¡¨
	toolbarProcesses: IRecordViewProcess[] = [];
	// å¯ä¸ä¸»é®å­æ®µåè¡¨
	uniqueFields: string[];
	// ææå
	allColumns: IColumnType[];
	// ææååç§°
	allColumnNames: string[];
	// ææåï¼å·²è½¬æ¢æé¦å­æ¯é¾è¡¨æ¹å¼
	allColumnsWithLetter: ColumnsWithLetter[];
	// ææçæ ç­¾æ°æ®
	categories: FetchElementAllCategoriesResult[];
	// éä¸­çæ ç­¾
	selectedLabels: Label[] = [];
	// ä¸ä¸é¡µæé®å¯ç¨æ§
	prevPageDisable = true;
	// ä¸ä¸é¡µæé®å¯ç¨æ§
	nextPageDisable = true;
	// ä¿å­çä¸ä¸é¡µçåå¼åæ°
	upRowNum: Array<number> = [];
	upDivide: Array<string[]> = [];
	// åå½åæ°æ®å¯¹åºçåæ°åæ°
	prevFetchRowNum?: number = null;
	prevFetchDivide?: string[] = null;
	// çé¢ä¸çåç§è®¾ç½®ç´æ¥æ å°å°è¯¥åæ°ç»æä¸­
	fetchParam: IFetchDataParam = { Limit: 50 };
	// è®°å½æ»æ°
	rowCount = -1;
	tableData: IFetchDataResult;
	// æå¼åªä¸ä¸ªæ½å±
	showLabelDrawer = true;
	// åè§å¾
	viewList: ElementViewDigest[];
	// å½åååè®¸çè¿ç®ç¬¦
	Operates: Operate[];
	// èæ¶
	timeConsuming = 0;
	// éæçè§å¾
	constViewItems: ElementViewDigest[] = [defaultColumnsItem, combLabelColumnsItem];
	// å½åéä¸­çè§å¾
	selectedView: ElementViewDigest;
	tableRowSelection = new SelectionModel<string>(true, []);
	refreshDataProgress: boolean; // æ­£å¨å·æ°æ°æ®
	refreshRowCountProgress: boolean; // æ­£å¨å·æ°è®°å½æ»æ°
}
